import WindowManager from '../components/window-manager';

WindowManager.initialize();
